import { render, staticRenderFns } from "./SideBarInfo.vue?vue&type=template&id=b78a108c&scoped=true&"
import script from "./SideBarInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarInfo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78a108c",
  null
  
)

export default component.exports